const DEFAULT_DELETE_ERROR_MESSAGE = 'Can\'t delete memory';

export function extractDeleteErrorMessage(error: unknown): string {
  const backendError = (error as { response?: { data?: { error?: string } } })
    ?.response?.data?.error;
  return backendError ?? DEFAULT_DELETE_ERROR_MESSAGE;
}
